import styles from './AdminCategories.module.css';
import React, { useEffect, useRef, useState } from "react";
import { DragNDropManager } from "@/commons/objects/dragNDrop/DragNDropManager";
import Cookies from "js-cookie";
import { environment } from "@/commons/configs/Config";
import { useInfoBox } from "@/commons/infoBox/InfoBox";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import FloatingInput from "@/commons/components/fields/floatingInput/FloatingInput";
import CustomSelect from "@/commons/components/fields/customSelect/CustomSelect";
import CustomButton from "@/commons/components/buttons/customButton/CustomButton";
import CategoryCard from "./objects/CategoryCard/CategoryCard";

const AdminCategories = () => {
    const { addInfo } = useInfoBox();
    const dragNDropManagerRef = useRef(null);

    const [categories, setCategories] = useState([]);
    const [usabilities, setUsabilities] = useState([]);
    const [categoryName, setCategoryName] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [categoryUsability, setCategoryUsability] = useState("none");
    const [isEditMode, setIsEditMode] = useState(false);
    const [formTouched, setFormTouched] = useState(false);
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        loadAll();
    }, []);

    useEffect(() => {
        if (categoryName !== "" || categoryId !== "" || categoryUsability !== "none" || formData !== null) {
            setFormTouched(true);
        }
    }, [categoryName, categoryId, categoryUsability, formData]);

    useEffect(() => {
        if (dragNDropManagerRef.current) {
            dragNDropManagerRef.current.submitAction = (data) => handleSubmit(data);
        }
    }, [categoryName, categoryId, categoryUsability]);

    const loadAll = async () => {
        const cats = await getCats();
        const usable = await getUsabilities();
        setCategories(await cats.json());
        setUsabilities(await usable.json());
    };

    const getCats = async () => {
        const userToken = Cookies.get(environment.accessToken);
        return fetch(environment.apiUrlOne + '/category/getAll', {
            method: 'GET',
            headers: { 'Authorization': userToken }
        });
    };

    const getUsabilities = async () => {
        const userToken = Cookies.get(environment.accessToken);
        return fetch(environment.apiUrlOne + '/category/usabilities', {
            method: 'GET',
            headers: { 'Authorization': userToken }
        });
    };

    const clearAll = () => {
        setCategoryName("");
        setCategoryUsability("none");
        setCategoryId("");
        setIsEditMode(false);
        setFormTouched(false);
        setFormData(null);
        dragNDropManagerRef.current.updateSubmitName("Crea Categoria");
        dragNDropManagerRef.current.loadJson(undefined);
    };

    const handleSubmit = (data) => {
        if (categoryName === "" || categoryUsability === "none") {
            addInfo("alert", "Dati mancanti", "Compila tutti i campi con i dati richiesti!", 5);
            return;
        }

        let name = categoryName;

        const categoryJSON = {
            id: categoryId !== "" ? categoryId : undefined,
            name,
            usable: categoryUsability,
            hidden: categoryId !== "" ? null : false,
            formattedForm: JSON.stringify(data),
            orderId: categoryId !== "" ? -1 : undefined
        };

        const url = categoryId !== "" ? '/category/edit' : '/category/create';

        fetch(environment.apiUrlOne + url, {
            method: 'POST',
            headers: {
                'Authorization': Cookies.get(environment.accessToken),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(categoryJSON)
        }).then(r => {
            if (r.status === 200) {
                addInfo("success", categoryId !== "" ? "Categoria Modificata" : "Categoria Creata", `La categoria è stata ${categoryId !== "" ? "modificata" : "creata"} correttamente!`, 5);
                loadAll();
                clearAll();
            } else {
                addInfo("alert", "Errore", `C'è stato un errore durante la ${categoryId !== "" ? "modifica" : "creazione"} della categoria!`, 5);
            }
        });
    };

    const handleEdit = (category) => {
        window.scrollTo(0, 0);
        setCategoryName(category.name);
        setCategoryId(category.id);
        setCategoryUsability(category.usable);
        setIsEditMode(true);
        setFormTouched(true);

        try {
            const parsed = category.formattedForm ? JSON.parse(category.formattedForm) : null;
            setFormData(parsed);
            dragNDropManagerRef.current.updateSubmitName("Modifica Categoria");
            dragNDropManagerRef.current.loadJson(parsed);
        } catch (err) {
            console.error("Errore parsing formattedForm:", err);
            setFormData(null);
        }
    };

    const deleteCategory = (categoryId) => {
        const userToken = Cookies.get(environment.accessToken);
        fetch(`${environment.apiUrlOne}/category/delete/${categoryId}`, {
            method: 'GET',
            headers: {
                'Authorization': userToken,
            }
        }).then((r) => {
            if (r.status === 200) {
                addInfo("success", "Categoria Eliminata", "La categoria è stata eliminata correttamente!", 5);
                loadAll();
            } else {
                addInfo("alert", "Errore", "C'è stato un errore durante l'eliminazione della categoria!", 5);
            }
        });
    };

    const toggleCategoryHidden = (category, status) => {
        let newStatus = !status;
        const updatedCategory = {
            id: category.id,
            hidden: newStatus,
        };

        fetch(environment.apiUrlOne + '/category/edit', {
            method: 'POST',
            headers: {
                'Authorization': Cookies.get(environment.accessToken),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedCategory)
        }).then(r => {
            if (r.status === 200) {
                addInfo("success", `Categoria ${newStatus ? "Disabilitata" : "Riabilitata"}`, "La categoria è stata aggiornata correttamente!", 5);
                loadAll();
            } else {
                addInfo("alert", "Errore", "C'è stato un errore durante l'aggiornamento dello stato!", 5);
            }
        });
    };

    const changeOrder = (categoryID, value) => {
        const userToken = Cookies.get(environment.accessToken);
        const data = { id: categoryID, orderId: value };

        fetch(environment.apiUrlOne + '/category/edit', {
            method: 'POST',
            headers: {
                'Authorization': userToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then((r) => {
            if (r.status === 200) {
                loadAll();
                addInfo("success", "Categoria aggiornata", `La categoria ${categoryID} è ora ordinata con Ordinamento: ${value}.`, 5);
            } else {
                loadAll();
                addInfo("alert", "Errore", "C'è stato un errore durante l'aggiornamento della categoria!", 5);
            }
        });
    };



    return (
        <>
            <div className="page__body">
                <Header />
                <div className="page__content">
                    <div className={styles.categoriesMainBox}><br />
                        <div className={styles.catsMain}>
                            <div className={styles.categoryList}>
                                <div className={styles.categoryListTitle}>Categorie Attive</div>
                                <div className={styles.categoryListBox}>
                                    {categories.filter(c => !c.hidden).map(category => (
                                        <CategoryCard key={category.id} category={category} usabilities={usabilities} onEdit={handleEdit}
                                                      onChangeOrder={changeOrder} onToggleStatus={toggleCategoryHidden} onDelete={deleteCategory} reload={loadAll} />
                                    ))}
                                </div>
                                <div className={styles.categoryListTitle}>Categorie Disabilitate</div>
                                <div className={styles.categoryListBoxDisabled}>
                                    {categories.filter(c => c.hidden).map(category => (
                                        <CategoryCard key={category.id} category={category} usabilities={usabilities} onEdit={handleEdit}
                                                      onChangeOrder={changeOrder} onToggleStatus={toggleCategoryHidden} onDelete={deleteCategory} reload={loadAll} />
                                    ))}
                                </div>
                            </div>
                            <div>
                                <div className={styles.categoryCreateTitle}>Crea Categoria</div>
                                <div className={styles.categoryCreateBox}>
                                    <div className={styles.categoryCreateBoxTopLeft}>
                                        {(isEditMode || formTouched) && (
                                            <>
                                                <CustomButton className={styles.categoryClearButton} onClick={clearAll}>Clear</CustomButton><br/>
                                            </>
                                        )}
                                        <div className={styles.categoryCreateBoxNames}>
                                            <FloatingInput type="text" label="Nome Categoria" value={categoryName} onChange={(e) => setCategoryName(e.target.value)} />
                                            <FloatingInput type="number" label="ID" value={categoryId} disabled={true} />
                                        </div>
                                        <CustomSelect
                                            label="Usabilità"
                                            id="categoryUsabilities"
                                            value={categoryUsability}
                                            options={[{ label: "Seleziona una usabilità", value: "none" }, ...usabilities.map(u => ({ label: u, value: u }))]}
                                            onChange={(val) => setCategoryUsability(val)}
                                        />
                                    </div>
                                    <div className={styles.categoryCreateBoxBottom}>
                                        <DragNDropManager
                                            ref={dragNDropManagerRef}
                                            mainLabel="Form della Categoria"
                                            mainLine2="Trascina i campi per creare il form della categoria"
                                            submitName="Crea Categoria"
                                        />
                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default AdminCategories;
